<template>
  <v-container class="mt-8">
    <h1>Administration</h1>
    <p class="mt-4">Select an area from the Administrator navigation to get started.</p>
  </v-container>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "AdminHome",
});
</script>
